module.exports = __webpack_public_path__ + "static/media/radical-women-cecilia-f-hill.53a7d70e.jpg";